import { SimpleGrid } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import FormInput from 'components/fields/home/FormInput';
import RadioInput from 'components/fields/home/RadioInput';
import Divider from 'views/home_form/components/Divider';

import getRadioYesNo from 'helpers/getRadioYesNo';

import { changeDwellingRiskAddress } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

import type { APIPersonalHomeApplicationForm } from 'types/api.types';

interface RiskAddressProps {
  dwelling: APIPersonalHomeApplicationForm['dwellings'][0];
  index: number;
}

const RiskAddress = ({ dwelling, index }: RiskAddressProps) => {
  const dispatch = useAppDispatch();

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(changeDwellingRiskAddress({ index, name, value }));
  };

  const onRadioChange = (value: string, name: string) => {
    dispatch(
      changeDwellingRiskAddress({
        index,
        name,
        value: value === 'true',
      }),
    );
  };

  return (
    <>
      <Divider mb="15px">Risk Address</Divider>
      <SimpleGrid columns={6} spacing="20px">
        <RadioInput
          section={SECTIONS.DWELLINGS}
          label="Same as Postal Address"
          subLabel={`Risk Address ${index + 1}`}
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          value={getRadioYesNo(dwelling.risk_address.same_as_postal_address)}
          onChange={(value: string) =>
            onRadioChange(value, 'same_as_postal_address')
          }
          stacked
          required
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Address"
          subLabel={`Risk Address ${index + 1}`}
          name="address"
          value={dwelling.risk_address.address || ''}
          onChange={onInputChange}
          required
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="City"
          subLabel={`Risk Address ${index + 1}`}
          name="city"
          value={dwelling.risk_address.city || ''}
          onChange={onInputChange}
          required
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Province"
          subLabel={`Risk Address ${index + 1}`}
          name="province"
          value={dwelling.risk_address.province || ''}
          onChange={onInputChange}
          required
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Postal Code"
          subLabel={`Risk Address ${index + 1}`}
          name="postal_code"
          value={dwelling.risk_address.postal_code || ''}
          onChange={onInputChange}
          required
        />

        <FormInput
          section={SECTIONS.DWELLINGS}
          label="Occupancy Type"
          subLabel={`Risk Address ${index + 1}`}
          name="occupancy_type"
          value={dwelling.risk_address.occupancy_type || ''}
          onChange={onInputChange}
        />
      </SimpleGrid>
    </>
  );
};

export default RiskAddress;
